export const currentIdentityKeys = {
  all: ['current-identity'] as const,
  businessProfile: (userId?: string) =>
    ['current-identity', 'business-profile', userId] as const,
  organisation: (userId?: string, companyId?: string | null) =>
    ['current-identity', 'organisation', userId, companyId] as const,
};
